<template>
  <UiButton
    v-bind="props"
    :class="
      cn(
        'hover:bg-primary/80 h-auto w-fit px-2 py-0.5 text-xs text-white',
        { 'hover:bg-primary': !isClickable },
        props.class
      )
    "
    :is="!isClickable ? 'div' : undefined"
  >
    <slot>{{ text }}</slot>
  </UiButton>
</template>

<script setup lang="ts">
import { type UiButtonProps } from "@finq/ui/components/ui/Button.vue"

const props = withDefaults(defineProps<UiButtonProps & { text?: string }>(), { text: "המלצה" })
const isClickable = computed(() => props.onClick || props.to)
</script>
